import React from 'react';
import { Provider } from 'react-redux';
import store from './store/app.store'
import { BrowserRouter } from "react-router-dom";
import Router from "./router/Router";
import ModalProvider from './components/shared/modal-provider/modal-provider';

function App() {

  return (
    <Provider store={store}>
      <ModalProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </ModalProvider>
    </Provider>
  );
}

export default App;
